import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Feedbacks from './pages/Feedbacks';
import CreateFeedback from './pages/CreateFeedback';
import CreateReverseFeedback from './pages/CreateReverseFeedback';
import FeedbackDetail from './pages/FeedbackDetail';
import ReverseFeedbackDetail from './pages/ReverseFeedbackDetail';
import Cycles from './pages/Cycles';
import Reports from './pages/Reports';
import Users from './pages/Users';
import BehavioralAdmin from './pages/BehavioralAdmin';
import PersonalDevelopment from './pages/PersonalDevelopment';
import TimeclockPage from './pages/TimeclockPage';
import Standups from './pages/Standups';
import FinanceWorkspace from './pages/FinanceHub';
import Layout from './components/Layout';
import RoleRoute from './components/RoleRoute';
import './App.css';

function App(): React.ReactElement {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks"
            element={
              <PrivateRoute>
                <Layout>
                  <Feedbacks />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks/create"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'manager']}>
                  <Layout>
                    <CreateFeedback />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks/reverse/create"
            element={
              <PrivateRoute>
                <RoleRoute allow={['developer']}>
                  <Layout>
                    <CreateReverseFeedback />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks/reverse/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <ReverseFeedbackDetail />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/feedbacks/:id"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'manager']}>
                  <Layout>
                    <FeedbackDetail />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/cycles"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'manager']}>
                  <Layout>
                    <Cycles />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'manager']}>
                  <Layout>
                    <Reports />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'developer']}>
                  <Layout>
                    <Users />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/behavioral"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr']}>
                  <Layout>
                    <BehavioralAdmin />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/desenvolvimento-pessoal"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr']}>
                  <Layout>
                    <PersonalDevelopment />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/ponto-eletronico"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'manager', 'developer']}>
                  <Layout>
                    <TimeclockPage />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/notas-fiscais"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr', 'manager', 'developer']}>
                  <Layout>
                    <TimeclockPage lockedTab="nf" />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/financeiro"
            element={
              <PrivateRoute>
                <RoleRoute allow={['admin', 'hr']}>
                  <Layout>
                    <FinanceWorkspace />
                  </Layout>
                </RoleRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/standups"
            element={
              <PrivateRoute>
                <Layout>
                  <Standups />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
